import { StyledSkeleton } from './styles';
import { ISkeleton } from './types';

const Skeleton = ({ height, width, shape }: ISkeleton) => {
  return <StyledSkeleton height={height} width={width} shape={shape} />;
};

export default Skeleton;
